export const HOME = "/home";
export const HOME_TWEET = HOME + "/tweet";
export const HOME_TRENDS = HOME + "/trends";
export const HOME_CONNECT = HOME + "/connect";

export const ACCOUNT = "/account";
export const ACCOUNT_SIGNIN = ACCOUNT + "/signin";
export const ACCOUNT_LOGIN = ACCOUNT + "/login";
export const ACCOUNT_FORGOT = ACCOUNT + "/forgot";
export const ACCOUNT_FORGOT_SEND_PASSWORD_RESET = ACCOUNT_FORGOT + "/send_password_reset";
export const ACCOUNT_FORGOT_CONFIRM_PIN_RESET = ACCOUNT_FORGOT + "/confirm_pin_reset";
export const ACCOUNT_FORGOT_RESET_PASSWORD = ACCOUNT_FORGOT + "/reset_password";
export const ACCOUNT_FORGOT_PASSWORD_RESET_COMPLETE = ACCOUNT_FORGOT + "/password_reset_complete";

export const NOTIFICATIONS = "/notifications";
export const NOTIFICATIONS_TIMELINE = NOTIFICATIONS + "/timeline";
export const NOTIFICATIONS_MENTIONS = NOTIFICATIONS + "/mentions";
export const NOTIFICATION = "/notification";

export const MESSAGES = "/messages";
export const MESSAGES_SETTINGS = MESSAGES + "/settings";

export const TOPICS = "/topics";
export const TOPICS_FOLLOWED = TOPICS + "/followed";
export const TOPICS_SUGGESTED = TOPICS + "/suggested";
export const TOPICS_NOT_INTERESTED = TOPICS + "/not_interested";

export const BOOKMARKS = "/bookmarks";
export const SUGGESTED = "/suggested";
export const LISTS = "/lists";
export const LISTS_MEMBERSHIPS = LISTS + "/memberships";
export const PROFILE = "/profile";
export const PROFILE_PHOTO = PROFILE + "/photo";
export const PROFILE_HEADER_PHOTO = PROFILE + "/header_photo";

export const USER = "/user";
export const USER_FOLLOWERS_YOU_FOLLOW = USER + "/followers_you_follow";

export const MODAL = "/modal";
export const SEARCH = "/search";
export const QUOTES = "/quotes";

export const SETTINGS = "/settings";
export const SETTINGS_SECURITY_AND_ACCOUNT_ACCESS = SETTINGS + "/security_and_account_access";
export const SETTINGS_PRIVACY_AND_SAFETY = SETTINGS + "/privacy_and_safety";
export const SETTINGS_NOTIFICATION = SETTINGS + "/notification";
// export const SETTINGS_ACCESSIBILITY_DISPLAY_AND_LANGUAGES = SETTINGS + "/accessibility_display_and_languages";
export const SETTINGS_ACCESSIBILITY_DISPLAY_AND_LANGUAGES = SETTINGS + "/display";
export const SETTINGS_ABOUT = SETTINGS + "/about";
export const SETTINGS_VERACITY = SETTINGS + "/veracity";
export const SETTINGS_INFO = SETTINGS + "/info";
export const SETTINGS_INFO_USERNAME = SETTINGS_INFO + "/username";
export const SETTINGS_INFO_PHONE = SETTINGS_INFO + "/phone";
export const SETTINGS_INFO_EMAIL = SETTINGS_INFO + "/email";
export const SETTINGS_INFO_COUNTRY = SETTINGS_INFO + "/country";
export const SETTINGS_INFO_LANGUAGES = SETTINGS_INFO + "/languages";
export const SETTINGS_INFO_GENDER = SETTINGS_INFO + "/gender";
export const SETTINGS_INFO_AGE = SETTINGS_INFO + "/age";
export const SETTINGS_PASSWORD = SETTINGS + "/password";
export const SETTINGS_TEAMS = SETTINGS + "/teams";
export const SETTINGS_DEACTIVATE = SETTINGS + "/deactivate";
export const SETTINGS_SECURITY = SETTINGS + "/security";
export const SETTINGS_SECURITY_LOGIN_VERIFICATION = SETTINGS_SECURITY + "/login_verification";
export const SETTINGS_SECURITY_APPS_AND_SESSIONS = SETTINGS_SECURITY + "/apps_and_sessions";
export const SETTINGS_SECURITY_CONNECTED_APPS = SETTINGS_SECURITY + "/connected_apps";
export const SETTINGS_SECURITY_SESSIONS = SETTINGS_SECURITY + "/sessions";
export const SETTINGS_SECURITY_SESSIONS_CURRENT = SETTINGS_SECURITY_SESSIONS + "/current";
export const SETTINGS_SECURITY_LOGIN_HISTORY = SETTINGS_SECURITY + "/login_history";
export const SETTINGS_SECURITY_DEVICES = SETTINGS_SECURITY + "/devices";
export const SETTINGS_PRIVACY_AND_SAFETY_AUDIENCE = SETTINGS_PRIVACY_AND_SAFETY + "/audience";
export const SETTINGS_PRIVACY_AND_SAFETY_TAGGING = SETTINGS_PRIVACY_AND_SAFETY + "/tagging";
export const SETTINGS_PRIVACY_AND_SAFETY_YOUR_TWEETS = SETTINGS_PRIVACY_AND_SAFETY + "/your_tweets";
export const SETTINGS_PRIVACY_AND_SAFETY_LOCATION = SETTINGS_PRIVACY_AND_SAFETY + "/location";
export const SETTINGS_PRIVACY_AND_SAFETY_CONTENT_YOU_SEE = SETTINGS_PRIVACY_AND_SAFETY + "/content_you_see";
// export const SETTINGS_PRIVACY_AND_SAFETY_MUTE_AND_BLOCK = SETTINGS_PRIVACY_AND_SAFETY + "/mute_and_block";
export const SETTINGS_PRIVACY_AND_SAFETY_MUTE_AND_BLOCK = SETTINGS_PRIVACY_AND_SAFETY + "/block";
export const SETTINGS_PRIVACY_AND_SAFETY_BLOCKED = SETTINGS_PRIVACY_AND_SAFETY + "/blocked";
export const SETTINGS_PRIVACY_AND_SAFETY_MUTED = SETTINGS_PRIVACY_AND_SAFETY + "/muted";
export const SETTINGS_PRIVACY_AND_SAFETY_MUTED_KEYWORDS = SETTINGS_PRIVACY_AND_SAFETY + "/muted_keywords";
export const SETTINGS_PRIVACY_AND_SAFETY_ADVANCED_FILTERS = SETTINGS_PRIVACY_AND_SAFETY + "/advanced_filters";
export const SETTINGS_PRIVACY_AND_SAFETY_DIRECT_MESSAGES = SETTINGS_PRIVACY_AND_SAFETY + "/direct_messages";
export const SETTINGS_PRIVACY_AND_SAFETY_SPACES = SETTINGS_PRIVACY_AND_SAFETY + "/spaces";
export const SETTINGS_PRIVACY_AND_SAFETY_CONTACTS = SETTINGS_PRIVACY_AND_SAFETY + "/contacts";
export const SETTINGS_PRIVACY_AND_SAFETY_CONTACTS_DASHBOARD = SETTINGS_PRIVACY_AND_SAFETY + "/contacts_dashboard";
export const SETTINGS_PRIVACY_AND_SAFETY_ADS_PREFERENCES = SETTINGS_PRIVACY_AND_SAFETY + "/ads_preferences";
export const SETTINGS_PRIVACY_AND_SAFETY_AUDIENCES = SETTINGS_PRIVACY_AND_SAFETY + "/audiences";
export const SETTINGS_PRIVACY_AND_SAFETY_OFF_TWITTER_ACTIVITY = SETTINGS_PRIVACY_AND_SAFETY + "/off_twitter_activity";
export const SETTINGS_PRIVACY_AND_SAFETY_DATA_SHARING_WITH_BUSINESS_PARTNERS = SETTINGS_PRIVACY_AND_SAFETY + "/data_sharing_with_business_partners";
export const SETTINGS_PRIVACY_AND_SAFETY_LOCATION_INFORMATION = SETTINGS_PRIVACY_AND_SAFETY + "/location_information";
export const SETTINGS_PRIVACY_AND_SAFETY_LOCATIONS = SETTINGS_PRIVACY_AND_SAFETY + "/locations";
export const SETTINGS_NOTIFICATION_FILTERS = SETTINGS_NOTIFICATION + "/filters";
export const SETTINGS_NOTIFICATION_PREFERENCES = SETTINGS_NOTIFICATION + "/preferences";
export const SETTINGS_NOTIFICATION_PUSH_NOTIFICATIONS = SETTINGS_NOTIFICATION + "/push_notifications";
export const SETTINGS_NOTIFICATION_EMAIL_NOTIFICATIONS = SETTINGS_NOTIFICATION + "/email_notifications";
export const SETTINGS_ACCESSIBILITY_DISPLAY_AND_LANGUAGES_ACCESSIBILITY = SETTINGS_ACCESSIBILITY_DISPLAY_AND_LANGUAGES + "/accessibility";
// export const SETTINGS_ACCESSIBILITY_DISPLAY_AND_LANGUAGES_DISPLAY = SETTINGS_ACCESSIBILITY_DISPLAY_AND_LANGUAGES + "/display";
export const SETTINGS_ACCESSIBILITY_DISPLAY_AND_LANGUAGES_DISPLAY = SETTINGS_ACCESSIBILITY_DISPLAY_AND_LANGUAGES + "/open";
export const SETTINGS_ACCESSIBILITY_DISPLAY_AND_LANGUAGES_LANGUAGES = SETTINGS_ACCESSIBILITY_DISPLAY_AND_LANGUAGES + "/languages";
export const SETTINGS_ACCESSIBILITY_DISPLAY_AND_LANGUAGES_DATA = SETTINGS_ACCESSIBILITY_DISPLAY_AND_LANGUAGES + "/data";
export const SETTINGS_ACCESSIBILITY_DISPLAY_AND_LANGUAGES_AUTOPLAY = SETTINGS_ACCESSIBILITY_DISPLAY_AND_LANGUAGES + "/autoplay";
export const SETTINGS_PERSONALIZATION = SETTINGS + "/personalization";
export const SETTINGS_CONTENT_PREFERENCES = SETTINGS + "/content_preferences";

export const LAUNCH_SOON = '/launch_soon';

export const NEWS = "/news";

export const RESPONSIVENESS_RESTRTICTION = "/phone_restriction"

export const DECLINED_TWEETS = "/declined_tweets"